import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section className="w-full bg-brand-dark px-2 py-16 sm:px-4 sm:py-24" data-id="element-48" data-mp="aua4y8rf39qx">
      <div className="mx-auto max-w-4xl" data-id="element-49" data-mp="fteex1m61bib">
        <div className="px-2" data-id="element-50" data-mp="fsbnmskxl71v">
          <SectionHeading tone="dark" eyebrow="Your Five Exclusive Bonuses" title="5 Professional Resources Included FREE With Your Purchase" intro="I’ve created five additional resources to help you study, practice, organize, and review periodontal concepts." data-id="element-51" data-mp="1un5vtm5ug11" />
        </div>

        <div className="mt-12 space-y-8" data-id="element-52" data-mp="3t1rdapm7w49z">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden rounded-3xl bg-white" data-id="element-53" data-mp="1m9qk3mnentne">
              <div className="flex items-center justify-between gap-3 bg-gold px-5 py-3" data-id="element-54" data-mp="1r931vszf6aj4">
                <span className="flex items-center gap-2 text-sm font-black uppercase tracking-widest text-brand-dark" data-id="element-55" data-mp="3ieg7x4yj891d">
                  <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-56" data-mp="3dfv46vk2n786" />
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-bold text-brand-dark" data-id="element-57" data-mp="3r5gkfy6hl8ci">
                  <s className="opacity-70" data-id="element-58" data-mp="3n4mwx5wyhvk5">{b.value}</s> <span className="ml-1 font-black" data-id="element-59" data-mp="3n5oi437oryfl">FREE</span>
                </span>
              </div>

              <img src={b.image} alt={`Bonus ${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-60" data-mp="2zfu7zter4nz1" />

              <div className="px-5 pb-8 pt-2 sm:px-10" data-id="element-61" data-mp="2uik5pd69khts">
                <h3 className="font-serif text-[26px] font-black leading-tight text-ink sm:text-4xl" data-id="element-62" data-mp="38hbhgsxnlrer">{b.title}</h3>
                <p className="mt-2 text-sm font-bold text-cta" data-id="element-63" data-mp="33fm77fi99hrq">
                  Reference value: <s className="text-muted" data-id="element-64" data-mp="np00ivstwib8">{b.value}</s> — Included FREE
                </p>
                <p className="mt-4 text-[16px] leading-relaxed text-ink/80 sm:text-[17px]" data-id="element-65" data-mp="irq4gxaxp8ef">{b.intro}</p>

                <p className="mt-6 text-xs font-black uppercase tracking-widest text-muted" data-id="element-66" data-mp="3chv4tp2jtam4">{b.listLabel}:</p>
                <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-67" data-mp="3hgoh5e63mvkp">
                  {b.list.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-68" data-mp="3lke1tsjnkt0g">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-69" data-mp="3qhwenu0sjsdq" />
                      <span data-id="element-70" data-mp="2tqlsz95b29rd">{item}</span>
                    </li>)}
                </ul>
                <p className="mt-5 text-xs italic leading-relaxed text-muted" data-id="element-71" data-mp="2xrns7pz82ltc">{b.note}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-12 px-2" data-id="element-72" data-mp="37kliwjedbh31">
          <CTAButton label="Yes, I Want All 5 Bonuses" tone="dark" data-id="element-73" data-mp="37lo88mw1lbgu" />
        </div>
      </div>
    </section>;
}